// P01021-142: lista completa de tipos de posición RCS, misma fuente autoritativa que
// domain/Enums/EnumHikRobot.js's SITE_TYPES_INFO en nakire-middleapi — antes solo tenía 5
// entradas (con "0" y "2" duplicando "No se sabe" sin corresponder a ningún tipo real de RCS,
// confirmado que ninguna fila de rcs_map los usa) y el resto de tipos reales salían en blanco.
export const position_type = {
  "-1": "Zona obstáculo",
  1: "Almacén",
  9: "Punto de inicio/fin de arco",
  10: "Estación de trabajo",
  11: "Estación de carga",
  12: "Cola",
  13: "Zona de rotación",
  15: "Puerta automática",
  16: "Zona de alta velocidad",
  18: "Esclusa de aire",
  19: "Zona de aparcamiento temporal",
  20: "Zona de buffer",
  22: "Zona de transferencia de ascensor",
  26: "Punto de conexión del mapa",
  28: "Zona de autochequeo",
  30: "Punto de espera",
  32: "Estación de cambio de batería",
  33: "Punto de conexión QR",
  34: "Punto de conexión láser",
  35: "Estación de carga inalámbrica",
  36: "Inicio de acoplamiento a almacén",
  45: "Estación de trabajo CTU",
  46: "Punto de espera CTU",
  52: "Punto de espera de ascensor",
  53: "Cabecera de pasillo",
  54: "Final de pasillo",
  55: "Buffer de pasillo",
  56: "Zona de carga",
  60: "Rack buffer (WMS)",
  61: "Zona de excepción",
  70: "Punto de drenaje",
};
export const map_pos_status = {
  0: { name: "Bloqueada", color: "danger" },
  1: { name: "Proceso de bloqueo", color: "warning" },
  2: { name: "Disponible", color: "success" },
  3: { name: "Ocupada", color: "primary" },
  4: { name: "Reservada", color: "primary" },
  5: { name: "Rack en camino", color: "info" },
  null: { name: "No establecido", color: "primary" },
};
export const map_colums = [
  {
    label: "Posición",
    field: "rcs_position_id", //rcs_position_id
    sort: "asc",
    width: 150,
  },
  {
    label: "Alias",
    field: "rcs_position_name",
    sort: "asc",
    width: 150,
  },
  {
    label: "Tipo de posición",
    field: "rcs_position_type_name", //rcs_position_type
    sort: "asc",
    width: 270,
  },
  {
    label: "Estado",
    field: "rcs_position_status_name", //rcs_position_status
    sort: "asc",
    width: 200,
  },
];
